/**
 * Hook for accessing organization context
 */
import { useContext } from 'react';
import OrganizationContext, {
  OrganizationContextProps,
} from '@src/v3/contexts/organizationContext';

/**
 * Hook to access organization context
 * @returns OrganizationContextProps
 */
export const useOrganization = (): OrganizationContextProps => {
  const context = useContext(OrganizationContext);

  if (!context) {
    throw new Error(
      'useOrganization must be used within an OrganizationProvider'
    );
  }

  return context;
};

export default useOrganization;
